/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/**
 * Checks if the Google reCAPTCHA script is injected in the document.
 *
 * @return {boolean} Returns true if the Google reCAPTCHA script is injected, false otherwise.
 */
export function checkRecaptchaInjected() {
    return !!document.querySelector('script[src*="/recaptcha/"]:not([src*="gstatic"])');
}

// cSpell:ignore gstatic
